/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Grid } from "@mui/material";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { RiPhoneFill } from "react-icons/ri";
import { getAssets } from "@unisearch/helpers";
import styles from "./map.module.scss";

export const ContactusMap = () => {
  return (
    <section className={styles.section_map}>
      <div className={styles.map_wrapper}>
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15934.945565289698!2d101.6568137!3d3.1640033!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x719e89cd891b2061!2sServiced%20Office%20Sri%20Hartamas%20by%20Avenue%20Business!5e0!3m2!1sen!2sbd!4v1640282149935!5m2!1sen!2sbd"
          width="100%"
          height="100%"
          allowFullScreen=""
          loading="lazy"
        ></iframe> */}
        <img src={getAssets("assets/map.png")} alt="map" />
      </div>
      Address:
      <div className={`${styles.container} container`}>
        <div className={styles.addrss_container_wrapper}>
          <div className={styles.addrss_wrapper}>
            <h2 className={styles.title}>Head office</h2>
            <ul className={styles.address_lists}>
              <li>
                <FaMapMarkerAlt className={styles.icon} />
                {/* <p>
                  <span className="fw600">Address:</span> <br /> Kuala Lumpur
                  Office <br />
                  N-3-9, Plaza Damas 2, <br />
                  No. 60, Jalan Sri Hartamas 1, <br />
                  50480, Sri Hartamas,
                  <br />
                  Kuala Lumpur
                  <br />
                </p> */}
                <p>
                  Suite 98 Level 3, 515 Kent Street, <br />
                  Sydney, NSW 2000
                </p>
              </li>
              <li>
                <MdEmail className={styles.icon} />
                <p>
                  <span className="fw600">Email: </span>
                  <br /> info@myunisearch.com
                </p>
              </li>
              <li>
                <RiPhoneFill className={styles.icon} />
                {/* <p>
                  <span className="fw600">Phone:</span>
                  <br /> +603 621 15347
                </p> */}
                <p>
                  <span className="fw600">Phone:</span>
                  <br /> +61 450 637 122
                </p>
              </li>
            </ul>
          </div>
          <div className={styles.addrss_wrapper}>
            <h4 className="fw600" style={{ marginTop: "0" }}>
              India office
            </h4>
            <div className={styles.india_office}>
              <div>
                <p className="fw600">Bangalore Office</p>
                <div className={styles.address_text}>
                  UNISEARCH, 2nd Floor,
                  <br /> RR Image, 4th Cross, Pandurang Nagar, Bannerghatta Main
                  Road, Bangalore 560076.
                </div>
              </div>
              <div>
                <p className="fw600">Chandigarh Office</p>
                <div className={styles.address_text}>
                  UNISEARCH, 3rd Floor,
                  <br /> S.C.O 68-69, Sector 17-B, Chandigarh.
                </div>
              </div>
            </div>

            <h4 className="fw600">Malaysia office</h4>
            <div className={styles.address_text}>
              N - 3 - 9, Plaza Damas 2, No. 60,
              <br /> Jalan Sri Hartamas 1, 50480 Sri Hartamas,
              <br /> Kuala Lumpur
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactusMap;
